import {
  MapPinIcon,
  PencilIcon,
  AdjustmentsHorizontalIcon,
  ArrowLeftIcon,
  ChatBubbleLeftEllipsisIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";

export default function ExploreMapStep({ onComplete, onBack, showBack }) {
  return (
    <div className="flex flex-col items-center text-center">
      {/* Top row: back button (left) + close (right) */}
      <div className="w-full flex items-start justify-between -mt-2 mb-2">
        {showBack ? (
          <button
            onClick={onBack}
            className="p-1 rounded-md text-white/60 hover:text-white/80"
            aria-label="Go back"
          >
            <ArrowLeftIcon className="h-5 w-5" />
          </button>
        ) : (
          <span />
        )}
        <button
          onClick={onComplete}
          className="p-1 rounded-md text-white/60 hover:text-white/80"
          aria-label="Close walkthrough"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>

      <h2 className="text-2xl font-bold text-white mb-2">
        Explore Nearby Notes
      </h2>
      <p className="text-white/70 text-sm mb-8 max-w-xs">
        Notes from people nearby appear as markers on the map. Here's how to get
        around.
      </p>

      {/* Visual guide */}
      <div className="w-full space-y-3 mb-8">
        <div className="flex items-center gap-3 bg-white/15 rounded-lg px-4 py-3">
          <MapPinIcon className="h-5 w-5 text-primary flex-shrink-0" />
          <span className="text-white/80 text-sm text-left">
            Tap any marker to read a note
          </span>
        </div>
        <div className="flex items-center gap-3 bg-white/15 rounded-lg px-4 py-3">
          <PencilIcon className="h-5 w-5 text-primary flex-shrink-0" />
          <span className="text-white/80 text-sm text-left">
            Use the pencil button to create notes
          </span>
        </div>
        <div className="flex items-center gap-3 bg-white/15 rounded-lg px-4 py-3">
          <AdjustmentsHorizontalIcon className="h-5 w-5 text-primary flex-shrink-0" />
          <span className="text-white/80 text-sm text-left">
            Adjust the search radius to find more notes
          </span>
        </div>
        <div className="flex items-center gap-3 bg-white/15 rounded-lg px-4 py-3">
          <ChatBubbleLeftEllipsisIcon className="h-5 w-5 text-primary flex-shrink-0" />
          <span className="text-white/80 text-sm text-left">
            Have feedback? Let us know in Settings
          </span>
        </div>
      </div>

      {/* Action */}
      <button
        onClick={onComplete}
        className="w-full py-2.5 rounded-lg bg-primary hover:bg-primary-hover text-text-inverse text-sm font-medium"
      >
        Get Started
      </button>
    </div>
  );
}
